(function (prototype) {
    if (typeof prototype.requestSubmit == "function")
        return;
    prototype.requestSubmit = function (submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        }
        else {
            submitter = document.createElement("input");
            submitter.type = "submit";
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
    function validateSubmitter(submitter, form) {
        submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'", "typeError");
        submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button", "typeError");
        submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
    }
    function raise(errorConstructor, message, name) {
        throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
    }
})(HTMLFormElement.prototype);
const isRecaptchaEnabled = true;
const initRecaptcha = () => {
    if (isRecaptchaEnabled && typeof grecaptcha == 'undefined') {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.google.com/recaptcha/api.js`;
        document.head.appendChild(script);
        contactForms && contactForms.length > 0 && contactForms.forEach((form, i) => {
            const recaptchaContainer = form.querySelector("[data-recaptcha]");
            //check that i have a recaptcha to render and that is not altready created
            if (recaptchaContainer && form.getAttribute("g-recaptcha-rendered") === null) {
                form.setAttribute("g-recaptcha-rendered", "true");
                setTimeout(() => {
                    grecaptcha.ready(() => {
                        const widgetId = grecaptcha.render(recaptchaContainer, {
                            'sitekey': '6LduVDokAAAAAKNAUah0kxMAZoqNAIp36fpjh8-E',
                            'size': 'invisible',
                            'tabindex': i,
                            'callback': submitAfterCaptcha
                        });
                        form.setAttribute("g-recaptcha-index", widgetId.toString());
                        return true;
                    });
                }, 4000);
            }
        });
    }
    return false;
};
const submitAfterCaptcha = (token) => {
    const formToSubmit = document.querySelector(`form[data-active-form='true']`);
    const recaptchaTextarea = formToSubmit.querySelector(".g-recaptcha-response");
    recaptchaTextarea.value = token;
    const submitButton = formToSubmit.querySelector("[submit-button]");
    formToSubmit.requestSubmit();
};
